import React, { useEffect, useState } from 'react'

export default function PartialRefundModal({
  open,
  order,
  submitting,
  onClose,
  onConfirm
}) {
  const [refundAmount, setRefundAmount] = useState('')
  const [confirmPhone, setConfirmPhone] = useState('')
  const [remark, setRemark] = useState('')

  const refundedAmount = Number(order?.refunded_amount || 0)
  const refundableAmount = Number(order?.amount || 0)
  const originalAmount = refundedAmount + refundableAmount

  useEffect(() => {
    if (open) {
      setRefundAmount(refundableAmount > 0 ? refundableAmount.toFixed(2) : '')
      setConfirmPhone('')
      setRemark('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  if (!open || !order) return null

  // 无手机号订单（设备用户）改用用户ID二次确认
  const hasPhone = !!String(order.phone || '').trim()

  const amountNum = Number(refundAmount)
  const amountValid = refundAmount.trim() !== ''
    && /^\d+(\.\d{1,2})?$/.test(refundAmount.trim())
    && amountNum > 0
    && Math.round(amountNum * 100) <= Math.round(refundableAmount * 100)

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold text-gray-900">确认部分退款</h3>
        <p className="mt-2 text-sm text-gray-600">仅微信/支付宝订单支持部分退款，部分退款不影响用户积分与会员。</p>

        <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
          <div>订单号：{order.order_no || '-'}</div>
          <div>用户：{order.nickname || order.username || '-'}</div>
          <div>手机号：{order.phone || '-'}</div>
          {!hasPhone && <div>用户ID：{order.user_id ?? '-'}</div>}
          <div className="mt-2 border-t border-gray-200 pt-2">
            <div>原支付金额：¥{originalAmount.toFixed(2)}</div>
            {refundedAmount > 0 && <div className="text-orange-600">已退金额：¥{refundedAmount.toFixed(2)}</div>}
            <div className="font-semibold text-red-600">可退金额：¥{refundableAmount.toFixed(2)}</div>
          </div>
        </div>

        <div className="mt-4">
          <label className="mb-2 block text-sm font-medium text-gray-700">退款金额（元）</label>
          <input
            type="text"
            inputMode="decimal"
            value={refundAmount}
            onChange={(e) => setRefundAmount(e.target.value)}
            placeholder="请输入退款金额"
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
            autoFocus
          />
          {refundAmount.trim() !== '' && !amountValid && (
            <p className="mt-1 text-xs text-red-600">
              退款金额需大于 0、最多两位小数且不超过可退金额 ¥{refundableAmount.toFixed(2)}
            </p>
          )}
        </div>

        <div className="mt-4">
          <label className="mb-2 block text-sm font-medium text-gray-700">备注（可选）</label>
          <input
            type="text"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="退款原因备注"
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
          />
        </div>

        <div className="mt-4">
          <label className="mb-2 block text-sm font-medium text-gray-700">
            {hasPhone ? '请输入用户手机号进行二次确认' : '请输入用户ID进行二次确认'}
          </label>
          <input
            type="text"
            value={confirmPhone}
            onChange={(e) => setConfirmPhone(e.target.value)}
            placeholder={hasPhone ? '请输入完整手机号' : '请输入完整用户ID'}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
          />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            取消
          </button>
          <button
            type="button"
            onClick={() => onConfirm(refundAmount.trim(), confirmPhone, remark.trim())}
            disabled={submitting || !amountValid || !confirmPhone.trim()}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-700 disabled:opacity-50"
          >
            {submitting ? '处理中...' : '确认部分退款'}
          </button>
        </div>
      </div>
    </div>
  )
}
